import { UserRequest } from '../request-models/user-request.model';
import { omitUndefined } from './wire-value-utils';

/** Builds the PUT /admin/users/:id body: only the hub's `ADMIN_USER_WRITABLE` fields that are set. */
export function toUserRequest(fields: UserRequest): UserRequest {
  return omitUndefined<UserRequest>({
    firstName: fields.firstName,
    lastName: fields.lastName,
    email: fields.email,
    phone: fields.phone,
    address: fields.address,
    city: fields.city,
    state: fields.state,
    zipCode: fields.zipCode,
    latitude: fields.latitude,
    longitude: fields.longitude,
    requiresPasswordReset: fields.requiresPasswordReset,
  });
}
